export default __webpack_public_path__ + "static/2-295ac811aeb5c99321425d0f522774e2.webp";